import React, { useEffect } from 'react';

import FrameIdsInput from 'components/FilterAutocomplete/components/FrameIdsInput/FrameIdsInput';
import MultipleFilters from 'components/FilterAutocomplete/components/MultipleFilters/MultipleFilters';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import { Filters } from 'context/FilterProvider/types/Filters';

type autocompleteProps = {
  label: string;
  filterKey: string;
  options: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
};

const FilterAutocomplete = ({
  filterKey,
  label,
  options,
  setSelectedFilters,
}: autocompleteProps) => {
  const { filters } = useFilters();

  useEffect(() => {
    setSelectedFilters((prevFilters) => {
      return {
        ...prevFilters,
        [filterKey as keyof Filters]: filters[filterKey as keyof Filters],
      };
    });
  }, [filters]);

  return (
    <>
      {label === 'Frame ID' ? (
        <FrameIdsInput
          options={options}
          setSelectedFilters={setSelectedFilters}
          filterKey={filterKey}
        />
      ) : (
        <MultipleFilters
          label={label}
          options={options}
          setSelectedFilters={setSelectedFilters}
          filterKey={filterKey}
          filters={filters}
        />
      )}
    </>
  );
};

export default FilterAutocomplete;
